import { useViewSettingsStore } from "..";
import editStyles from "../components/Edit.module.css";
import { DetailsPanelState } from "../store/ViewSettingsStore";

export default function useRowClassName(): string {
    const viewSettingsStore = useViewSettingsStore();

    return viewSettingsStore.detailsPanelState === DetailsPanelState.Left && !viewSettingsStore.isDetailsFullScreen
        ? editStyles.rowSlim
        : editStyles.row;
}